import { Modal } from "antd"
import { useRevokeRoleAssignment } from "@mimber/client/mimber-organization"
import { message } from "@mimber/ui-web"
import type { RoleAssignmentWithRelationsDto } from "@mimber/schema"

export interface ShowRevokeRoleAssignmentModalOptions {
  assignment: RoleAssignmentWithRelationsDto
}

export const useRevokeRoleAssignmentModal = (roleUuid: string) => {
  const [modal, contextHolder] = Modal.useModal()
  const revokeMutation = useRevokeRoleAssignment(roleUuid, {
    onSuccess: () => {
      message.success("Assignment revoked successfully")
    },
    onError: (err) => {
      message.error(`Failed to revoke assignment: ${err.message}`)
    },
  })

  const showRevokeRoleAssignmentModal = ({
    assignment,
  }: ShowRevokeRoleAssignmentModalOptions): void => {
    const memberName =
      assignment.membership.user.firstName &&
      assignment.membership.user.lastName
        ? `${assignment.membership.user.firstName} ${assignment.membership.user.lastName}`
        : assignment.membership.user.email

    modal.confirm({
      title: "Revoke Assignment",
      content: `Are you sure you want to revoke the role assignment for "${memberName}"? This member will lose the permissions from this role.`,
      okText: "Revoke",
      okType: "primary",
      okButtonProps: { danger: true },
      cancelText: "Cancel",
      onOk: () =>
        new Promise<void>((resolve, reject) => {
          revokeMutation.mutate(
            { assignmentUuid: assignment.uuid },
            {
              onSuccess: () => resolve(),
              onError: () => reject(),
            }
          )
        }),
    })
  }

  return {
    contextHolder,
    showRevokeRoleAssignmentModal,
  }
}
